// ============================================
// gsap scrollTrigger
// ============================================
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import Lenis from 'lenis';

// ============================================
// Lenis
// ============================================
const lerp = 0.12;
const duration = 1.6;

export let lenis = new Lenis({
  lerp,
  duration,
  smoothWheel: true,
  smoothTouch: false,
});

//初期設定
lenis.on('scroll', ScrollTrigger.update);
const _raf = (time) => lenis.raf(time * 1000);
gsap.ticker.add(_raf);
gsap.ticker.lagSmoothing(1000, 16);

const REINIT_MS = 60 * 1000;
setInterval(() => {
  gsap.ticker.remove(_raf);
  lenis.destroy();

  lenis = new Lenis({
    lerp,
    duration,
    smoothWheel: true,
    smoothTouch: true,
  });

  lenis.on('scroll', () => ScrollTrigger.update());
  gsap.ticker.add(_raf);
  ScrollTrigger.refresh();
}, REINIT_MS);

// ============================================
// ページ内リンク
// ============================================
function lenisPageScroll() {
  const links = document.querySelectorAll('a[href^="#"]:not(.-no-smooth, .l-header__skip-content)');
  if (links.length === 0) return;

  const headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--size-header-h');
  const headerHeightNum = headerHeight.split('px')[0];

  const scrollToAnchor = (targetLink) => {
    if (!lenis) return;

    lenis.scrollTo(targetLink, {
      offset: headerHeightNum,
      lerp: 0.2,
      duration: 1.2,
    });
  };

  links.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();

      let targetLink = el.getAttribute('href');
      if (!targetLink || targetLink === '#') targetLink = 'body';

      scrollToAnchor(targetLink);
    });
  });
}

// ============================================
// スクロールアニメーション
// ============================================
function inViewAnm() {
  ScrollTrigger.batch('.js-inview', {
    start: 'top 75%',
    end: 'bottom 75%',
    once: true,
    //markers: true,

    onEnter: (batch) => {
      batch.forEach((el) => el.classList.add('is-active'));
    },
  });
}

// ============================================
// 画像
// ============================================
function inImg() {
  ScrollTrigger.batch('.js-inImg', {
    start: 'top 75%',
    end: 'bottom 75%',
    once: true,
    //markers: true,

    onEnter: (batch) => {
      batch.forEach((el) => el.classList.add('is-active'));
    },
  });
}

// ============================================
// タイトルアニメーション
// ============================================
function titleAnm() {
  const targets = document.querySelectorAll('.js-title');
  if (!targets) return;
  ScrollTrigger.batch('.js-title', {
    start: 'top 75%',
    end: 'bottom 75%',
    once: true,
    //markers: true,

    onEnter: (batch) => {
      batch.forEach((el) => el.classList.add('is-active'));
    },
  });

  targets.forEach((el) => {
    const nodes = el.childNodes;
    let result = '';

    nodes.forEach((node) => {
      // テキストノードだけ処理
      if (node.nodeType === 3) {
        const text = node.textContent;

        result += text
          .split('')
          .map((char) => {
            if (char === ' ') return ' '; // 空白はそのまま
            return `<span class="char">${char}</span>`;
          })
          .join('');
      }

      // <br>とかはそのまま残す
      else if (node.nodeType === 1) {
        result += node.outerHTML;
      }
    });

    el.innerHTML = result;
  });
}

// ============================================
// TOP MV
// ============================================
function topMv() {
  const mv = document.querySelector('.p-index-mv__bg-in');
  const bgWrap = document.querySelector('.p-index-mv__bgWrap');
  const animPin = document.querySelector('.p-index-mv__anim-pin');
  const anim = document.querySelector('.p-index-mv__anim');

  if (!mv || !bgWrap || !animPin || !anim) return;

  // 背景固定
  ScrollTrigger.create({
    trigger: mv,
    start: 'top top',
    end: 'bottom bottom',
    pin: bgWrap,
    pinSpacing: false,
  });

  ScrollTrigger.create({
    trigger: mv,
    start: 'top top',
    end: 'bottom bottom',
    pin: animPin,
    pinSpacing: false,
  });

  gsap.fromTo(
    anim,
    {
      scale: 1,
    },
    {
      scale: 4.3,
      ease: 'none',
      scrollTrigger: {
        trigger: mv,
        start: '40% top',
        end: 'center bottom',
        scrub: 1.4,
        invalidateOnRefresh: true,
        anticipatePin: 1,
      },
    }
  );
}

export { lenisPageScroll, inViewAnm, topMv, titleAnm, inImg };
